import React, { useState } from 'react';
import { Section, CTAButton } from './Shared';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
export const Closing = () => {
  const [showRefundPolicy, setShowRefundPolicy] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  return <>
      <Section className="bg-coral-dark text-white py-20" data-id="element-24">
        <div className="max-w-3xl mx-auto text-center" data-id="element-25">
          <h2 className="font-montserrat font-black text-4xl md:text-6xl uppercase leading-tight mb-8 [text-shadow:_2px_2px_8px_rgba(0,0,0,0.4)] text-[#E8533F]" data-id="element-26">
            No esperes sentirte lista
          </h2>
          <p className="font-opensans text-2xl md:text-3xl font-bold mb-12 text-white" data-id="element-27">
            La confianza no viene antes
            <br data-id="element-28" />
            Viene después de empezar
          </p>
          <CTAButton text="Quiero empezar ahora" subtext="Acceso inmediato. Empezás hoy." className="[&>button]:bg-black [&>button]:text-white [&>button]:shadow-[0_8px_0px_#333] [&>button:hover]:bg-gray-900 [&>button]:border-black" data-id="element-29" />
        </div>
      </Section>

      <Section dark className="bg-black text-white py-24" data-id="element-30">
        <div className="max-w-3xl mx-auto text-center" data-id="element-31">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight mb-8" data-id="element-32">
            Tu contenido no va a empezar solo
          </h2>
          <p className="font-opensans text-xl md:text-2xl text-gray-300 mb-12" data-id="element-33">
            Podés seguir pensando o podés empezar hoy
            <br data-id="element-34" />
            <span className="font-bold text-white mt-4 block" data-id="element-35">
              La diferencia no es el talento. Es la acción constante.
            </span>
          </p>
          <CTAButton text="Empezar ahora" isExternal={true} data-id="element-36" />
        </div>
      </Section>

      <footer className="bg-white text-black text-center py-8 text-sm border-t border-gray-200" data-id="element-37">
        <div className="flex justify-center items-center gap-4 mb-4" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/3gG2f1UKZEeyMV6ukZ9XLU/MP_RGB_HANDSHAKE_color_horizontal.svg" alt="Mercado Pago" className="h-8 object-contain" data-id="element-39" />
          <img src="https://cdn.magicpatterns.com/uploads/qyQW7QxRvCJm4Rtgo1Nq9r/visa-brandmark-blue-1960x622.webp" alt="Visa" className="h-5 object-contain" data-id="element-40" />
          <img src="https://cdn.magicpatterns.com/uploads/wmF7rZEFfiNHBgR17qRCkv/ma_symbol.svg" alt="Mastercard" className="h-8 object-contain" data-id="element-41" />
        </div>
        <p className="text-black/60" data-id="element-42">
          © {new Date().getFullYear()} De 0 a Influencer &middot;{' '}
          <button onClick={() => setShowPrivacyPolicy(true)} className="underline hover:text-black transition-colors" data-id="element-43">
            Política de privacidad
          </button>{' '}
          &middot;{' '}
          <button onClick={() => setShowRefundPolicy(true)} className="underline hover:text-black transition-colors" data-id="element-44">
            Política de reembolso
          </button>
        </p>
      </footer>

      <AnimatePresence data-id="element-45">
        {showRefundPolicy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setShowRefundPolicy(false)} data-id="element-46">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl p-8 md:p-10 max-w-lg w-full relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-47">
              <button onClick={() => setShowRefundPolicy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-black transition-colors" data-id="element-48">
                <XIcon className="w-6 h-6" data-id="element-49" />
              </button>

              <h3 className="font-montserrat font-black text-2xl md:text-3xl text-black mb-6 text-center" data-id="element-50">
                Política de reembolso
              </h3>

              <div className="space-y-4 font-opensans text-gray-700 text-center italic" data-id="element-51">
                <p data-id="element-52">
                  Como este es un producto digital y de acceso inmediato, no
                  realizamos reembolsos una vez realizada la compra.
                </p>
                <p data-id="element-53">
                  Sin embargo, si tenés algún problema con la descarga o el
                  acceso, escribinos y te lo solucionamos al instante.
                </p>
                <p className="font-bold text-black not-italic" data-id="element-54">
                  Queremos que tengas una gran experiencia.
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-55">
        {showPrivacyPolicy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/60" onClick={() => setShowPrivacyPolicy(false)} data-id="element-56">
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 30,
          stiffness: 300
        }} className="absolute right-0 top-0 h-full w-full max-w-xl bg-white shadow-2xl overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-57">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-58">
                <h3 className="font-montserrat font-black text-xl text-black" data-id="element-59">
                  📄 Política de Privacidad
                </h3>
                <button onClick={() => setShowPrivacyPolicy(false)} className="text-gray-400 hover:text-black transition-colors" data-id="element-60">
                  <XIcon className="w-6 h-6" data-id="element-61" />
                </button>
              </div>

              <div className="px-6 py-8 font-opensans text-gray-700 space-y-8" data-id="element-62">
                <p className="text-sm text-gray-500" data-id="element-63">
                  📅 Última actualización: 31/03/2026
                </p>

                <section data-id="element-64">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-65">
                    1. Introducción
                  </h4>
                  <p className="mb-3" data-id="element-66">
                    Valordigital gestiona esta tienda y sitio web, incluyendo
                    datos, contenido, funciones, herramientas, productos y
                    servicios (los "Servicios"), con tecnología de Shopify.
                  </p>
                  <p className="mb-3" data-id="element-67">
                    Esta Política de Privacidad explica cómo se recopila,
                    utiliza y divulga tu información personal cuando:
                  </p>
                  <ul className="space-y-1 ml-4" data-id="element-68">
                    <li data-id="element-69">✔️ Visitás el sitio</li>
                    <li data-id="element-70">✔️ Usás los servicios</li>
                    <li data-id="element-71">✔️ Realizás compras o transacciones</li>
                    <li data-id="element-72">✔️ Te comunicás con la empresa</li>
                  </ul>
                  <p className="mt-3 text-sm bg-gray-50 p-3 rounded-lg" data-id="element-73">
                    👉 En caso de conflicto con los Términos del Servicio,
                    prevalece esta Política respecto a datos personales.
                  </p>
                </section>

                <section data-id="element-74">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-75">
                    2. Información personal que se recopila
                  </h4>
                  <p className="mb-3" data-id="element-76">
                    Se entiende por "información personal" cualquier dato que
                    permita identificarte directa o indirectamente.
                  </p>
                  <h5 className="font-bold text-black mb-2" data-id="element-77">
                    📌 Tipos de datos recopilados
                  </h5>
                  <div className="space-y-2 text-sm" data-id="element-78">
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-79">
                      <span className="font-bold text-black shrink-0" data-id="element-80">
                        Datos de contacto
                      </span>
                      <span data-id="element-81">Nombre, dirección, email, teléfono</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-82">
                      <span className="font-bold text-black shrink-0" data-id="element-83">
                        Información financiera
                      </span>
                      <span data-id="element-84">Tarjetas, pagos, transacciones</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-85">
                      <span className="font-bold text-black shrink-0" data-id="element-86">
                        Datos de cuenta
                      </span>
                      <span data-id="element-87">Usuario, contraseña, preferencias</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-88">
                      <span className="font-bold text-black shrink-0" data-id="element-89">
                        Información de transacciones
                      </span>
                      <span data-id="element-90">Compras, carrito, devoluciones</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-91">
                      <span className="font-bold text-black shrink-0" data-id="element-92">
                        Comunicaciones
                      </span>
                      <span data-id="element-93">Mensajes enviados al soporte</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-94">
                      <span className="font-bold text-black shrink-0" data-id="element-95">
                        Información del dispositivo
                      </span>
                      <span data-id="element-96">IP, navegador, conexión</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-97">
                      <span className="font-bold text-black shrink-0" data-id="element-98">
                        Datos de uso
                      </span>
                      <span data-id="element-99">Cómo navegás e interactuás con el sitio</span>
                    </div>
                  </div>
                </section>

                <section data-id="element-100">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-101">
                    3. Fuentes de información
                  </h4>
                  <p className="mb-2" data-id="element-102">Los datos se obtienen de:</p>
                  <ul className="space-y-1 ml-4" data-id="element-103">
                    <li data-id="element-104">✔️ Directamente del usuario</li>
                    <li data-id="element-105">✔️ Automáticamente (cookies y tecnología)</li>
                    <li data-id="element-106">✔️ Proveedores de servicios</li>
                    <li data-id="element-107">✔️ Partners o terceros</li>
                  </ul>
                </section>

                <section data-id="element-108">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-109">
                    4. Cómo se usa la información
                  </h4>
                  <h5 className="font-bold text-black mb-2" data-id="element-110">
                    🎯 Principales usos
                  </h5>
                  <div className="space-y-2 text-sm" data-id="element-111">
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-112">
                      <span className="font-bold text-black shrink-0" data-id="element-113">
                        Prestación del servicio
                      </span>
                      <span data-id="element-114">Procesar pedidos, pagos, envíos</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-115">
                      <span className="font-bold text-black shrink-0" data-id="element-116">
                        Personalización
                      </span>
                      <span data-id="element-117">Recomendaciones y experiencia adaptada</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-118">
                      <span className="font-bold text-black shrink-0" data-id="element-119">
                        Marketing y publicidad
                      </span>
                      <span data-id="element-120">Emails, anuncios, promociones</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-121">
                      <span className="font-bold text-black shrink-0" data-id="element-122">
                        Seguridad
                      </span>
                      <span data-id="element-123">Prevención de fraude y protección</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-124">
                      <span className="font-bold text-black shrink-0" data-id="element-125">
                        Atención al cliente
                      </span>
                      <span data-id="element-126">Responder consultas</span>
                    </div>
                    <div className="flex gap-2 bg-gray-50 p-3 rounded-lg" data-id="element-127">
                      <span className="font-bold text-black shrink-0" data-id="element-128">
                        Cumplimiento legal
                      </span>
                      <span data-id="element-129">Obligaciones legales y procesos judiciales</span>
                    </div>
                  </div>
                </section>

                <section data-id="element-130">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-131">
                    5. Cómo se comparte la información
                  </h4>
                  <p className="mb-2" data-id="element-132">Se puede compartir con:</p>
                  <ul className="space-y-1 ml-4" data-id="element-133">
                    <li data-id="element-134">🛠️ Proveedores (pagos, envíos, IT)</li>
                    <li data-id="element-135">📢 Partners de marketing</li>
                    <li data-id="element-136">🤝 Afiliados del negocio</li>
                    <li data-id="element-137">⚖️ Autoridades legales</li>
                  </ul>
                  <p className="mt-3 text-sm bg-gray-50 p-3 rounded-lg" data-id="element-138">
                    👉 También cuando el usuario lo autoriza o solicita.
                  </p>
                </section>

                <section data-id="element-139">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-140">
                    6. Relación con Shopify
                  </h4>
                  <p className="mb-2" data-id="element-141">
                    El sitio funciona sobre Shopify, que también recopila y
                    procesa datos para:
                  </p>
                  <ul className="space-y-1 ml-4" data-id="element-142">
                    <li data-id="element-143">✔️ Mejorar los servicios</li>
                    <li data-id="element-144">✔️ Personalizar la experiencia</li>
                    <li data-id="element-145">✔️ Gestionar funcionalidades avanzadas</li>
                  </ul>
                  <p className="mt-3 text-sm bg-gray-50 p-3 rounded-lg" data-id="element-146">
                    👉 Shopify puede usar datos provenientes de múltiples
                    tiendas dentro de su plataforma.
                  </p>
                </section>

                <section data-id="element-147">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-148">
                    7. Sitios de terceros
                  </h4>
                  <p data-id="element-149">El sitio puede incluir enlaces externos.</p>
                  <p className="mt-2 text-sm bg-amber-50 p-3 rounded-lg border border-amber-200" data-id="element-150">
                    ⚠️ No se garantiza la seguridad ni privacidad en esos
                    sitios.
                  </p>
                </section>

                <section data-id="element-151">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-152">
                    8. Datos de menores
                  </h4>
                  <ul className="space-y-1 ml-4" data-id="element-153">
                    <li data-id="element-154">✔️ No está dirigido a menores</li>
                    <li data-id="element-155">✔️ No se recopilan datos intencionalmente</li>
                    <li data-id="element-156">✔️ Padres pueden solicitar eliminación de datos</li>
                  </ul>
                </section>

                <section data-id="element-157">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-158">
                    9. Seguridad y retención
                  </h4>
                  <ul className="space-y-1 ml-4" data-id="element-159">
                    <li data-id="element-160">✔️ No existe seguridad 100% garantizada</li>
                    <li data-id="element-161">
                      ✔️ Se recomienda no enviar datos sensibles por canales
                      inseguros
                    </li>
                    <li data-id="element-162">
                      ✔️ Los datos se conservan según necesidad legal y
                      operativa
                    </li>
                  </ul>
                </section>

                <section data-id="element-163">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-164">
                    10. Derechos del usuario
                  </h4>
                  <p className="mb-2" data-id="element-165">
                    Dependiendo del país, podés tener derecho a:
                  </p>
                  <ul className="space-y-1 ml-4" data-id="element-166">
                    <li data-id="element-167">📂 Acceder a tus datos</li>
                    <li data-id="element-168">❌ Solicitar eliminación</li>
                    <li data-id="element-169">✏️ Rectificar información</li>
                    <li data-id="element-170">📦 Portabilidad de datos</li>
                    <li data-id="element-171">📩 Gestionar comunicaciones (opt-out de marketing)</li>
                  </ul>
                  <p className="mt-3 text-sm bg-gray-50 p-3 rounded-lg" data-id="element-172">
                    👉 Puede requerirse verificación de identidad.
                  </p>
                </section>

                <section data-id="element-173">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-174">
                    11. Reclamaciones
                  </h4>
                  <p className="mb-2" data-id="element-175">Podés:</p>
                  <ul className="space-y-1 ml-4" data-id="element-176">
                    <li data-id="element-177">✔️ Contactar directamente a la empresa</li>
                    <li data-id="element-178">✔️ Reclamar ante autoridades de protección de datos</li>
                  </ul>
                </section>

                <section data-id="element-179">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-180">
                    12. Transferencias internacionales
                  </h4>
                  <p className="mb-2" data-id="element-181">
                    Los datos pueden almacenarse o procesarse fuera de tu país.
                  </p>
                  <p data-id="element-182">Se utilizan mecanismos legales como:</p>
                  <ul className="space-y-1 ml-4 mt-1" data-id="element-183">
                    <li data-id="element-184">✔️ Cláusulas contractuales estándar (SCC)</li>
                  </ul>
                </section>

                <section data-id="element-185">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-186">
                    13. Cambios en la política
                  </h4>
                  <p data-id="element-187">
                    La política puede actualizarse en cualquier momento. Se
                    notificará según lo exija la ley.
                  </p>
                </section>

                <section data-id="element-188">
                  <h4 className="font-montserrat font-bold text-lg text-black mb-3" data-id="element-189">
                    14. Contacto
                  </h4>
                  <div className="bg-gray-50 p-4 rounded-lg space-y-2" data-id="element-190">
                    <p data-id="element-191">
                      📧 Email:{' '}
                      <a href="mailto:soportevalordigitalpro@gmail.com" className="text-coral underline" data-id="element-192">
                        soportevalordigitalpro@gmail.com
                      </a>
                    </p>
                    <p data-id="element-193">
                      📍 Dirección: Av. Libertador 4800, Buenos Aires, Argentina
                    </p>
                  </div>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};